import {useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation} from 'react-router'

import {deviceInfoSlice, selectDeviceInfo} from '~/reducers/deviceInfo'
import {AppDispatch} from '~/stores'
import {getBrowserFingerprint} from '~/utils/helper'

function parseDeviceInfo(deviceinfo: string) {
  const tryParse = (value: string) => {
    try {
      return JSON.parse(value || '{}') || {}
    } catch (error) {
      return null
    }
  }

  const level0 = tryParse(deviceinfo)
  if (level0) return level0

  // 部分链接会被额外编码 1-2 次，这里按层解码并重试 JSON 解析
  try {
    const decoded1 = decodeURIComponent(deviceinfo)
    const level1 = tryParse(decoded1)
    if (level1) return level1

    const decoded2 = decodeURIComponent(decoded1)
    const level2 = tryParse(decoded2)
    if (level2) return level2
  } catch (error) {
    // 忽略解码错误，由下方统一抛出
  }

  throw new Error('Failed to parse deviceinfo')
}

function getDeviceInfoFromUrl(search: string, hash: string) {
  const searchParams = new URLSearchParams(search)
  const normalValue = searchParams.get('deviceinfo')
  if (normalValue) {
    // 端上若把 # 直接放进参数值，浏览器会把 # 后内容放到 location.hash，导致 search 中的值被截断
    if (hash) return `${normalValue}${hash}`
    return normalValue
  }

  // 兜底：部分端上拼接参数时未编码 #，会导致 search 被截断，改从完整 href 提取
  if (typeof window !== 'undefined') {
    const {href} = window.location
    const matched = href.match(/[?&]deviceinfo=([^&]*)/)
    if (matched?.[1]) return matched[1]
  }

  return null
}

export function InitDeviceInfo() {
  const dispatch = useDispatch<AppDispatch>()
  const location = useLocation()
  const deviceInfo = useSelector(selectDeviceInfo)

  const deviceinfo = useMemo(() => {
    return getDeviceInfoFromUrl(location.search, location.hash)
  }, [location.search, location.hash])

  useEffect(() => {
    if (deviceinfo) {
      try {
        const deviceinfoJson = parseDeviceInfo(deviceinfo)
        dispatch(deviceInfoSlice.actions.set(deviceinfoJson))
      } catch (error) {
        console.error('Failed to parse deviceinfo:', error)
      }
    }
  }, [dispatch, deviceinfo])

  useEffect(() => {
    if (typeof window !== 'undefined' && !deviceInfo.device_fingerprint) {
      getBrowserFingerprint().then((fingerprint) => {
        dispatch(
          deviceInfoSlice.actions.set({
            device_fingerprint: fingerprint,
          })
        )
      })
    }
  }, [dispatch, deviceInfo.device_fingerprint])
  return null
}
